import React from 'react';

import { get as getConstants } from '@lumapps/constants';
import { useDispatch, useStore } from '@lumapps/redux/react';
import { BaseStore } from '@lumapps/redux/types';

import { AppId } from '../constants';
import { previousRouteSelector } from '../ducks/selectors';
import { actions } from '../ducks/slice';
import { setCurrentPage } from '../ducks/thunks';
import { useCurrentRoute } from './useCurrentRoute';
import { useRouter } from './useRouter';

const { applicationId } = getConstants();
const ENABLED_APPS_FOR_ON_AFTER_ROUTE = [AppId.frontOffice, AppId.backOffice, AppId.webview];

export const useCurrentPageEffect = (id: string, onPageChanged?: (pageId: string) => void) => {
    const dispatch = useDispatch();
    const store = useStore<BaseStore>();
    const currentRoute = useCurrentRoute();
    const { onAfterRoute } = useRouter();

    React.useEffect(() => {
        dispatch(setCurrentPage(id, onPageChanged));
    }, [id, dispatch, onPageChanged]);

    React.useEffect(() => {
        if (ENABLED_APPS_FOR_ON_AFTER_ROUTE.includes(applicationId)) {
            dispatch(actions.setCurrentRoute(currentRoute));

            const previousRoute = previousRouteSelector(store.getState());
            if (onAfterRoute && previousRoute) {
                onAfterRoute(currentRoute, previousRoute);
            }
        }
    }, [currentRoute, dispatch, onAfterRoute, store]);
};
